import React, { useRef } from 'react';

import {
  Flex, Input, Text, InputProps, HStack, Image, Spinner,
} from '@chakra-ui/react';
import { useMutation } from 'react-query';

import { uploadFile } from 'api/s3';
import { Icon } from 'components/icon';

interface FileInputProps extends Omit<InputProps, 'onChange'> {
  isEmpty: boolean
  isFetching?: boolean
  label?:string
  onChange?: (_url: string) => void
}

function Preview({ file, url }) {
  if (file) {
    return (
      <Image
        width="50%"
        src={URL.createObjectURL(file)}
      />
    );
  }
  if (url) {
    return (
      <Image
        width="50%"
        src={url}
      />
    );
  }
  return (
    <Icon
      w={10}
      h={10}
      alignSelf="center"
      alignItems="center"
      justifyContent="center"
      size="lg"
      color="gray.300"
      name="upload"
    />
  );
}

const FileInput = ({
  name, label, value, onChange, accept, isFetching = false, ...rest
}: FileInputProps) => {
  const ref = useRef<HTMLInputElement>(null);

  const { mutate, isLoading } = useMutation((file:File) => {
    const formData = new FormData();
    formData.append('file', file);
    return uploadFile(formData);
  }, {
    onSuccess: ({ data }) => {
      onChange(data.url);
    },
  });

  return (
    <Flex>
      <Input
        type="file"
        ref={ref}
        hidden
        name={name}
        onChange={(e) => {
          mutate(e.target?.files?.[0]);
        }}
        accept={accept}
        {...rest}
      />
      <HStack
        alignItems="center">
        {(isLoading || isFetching) && <Spinner />}
        <Flex
          cursor="pointer"
          onClick={() => ref?.current?.click()}
          borderRadius={4}
          border="1px solid"
          borderColor="gray.150"
          alignItems="center"
          justifyContent="center">
          {(accept === 'application/pdf' && value) ? (
            <HStack
              px={2}
              onClick={() => window.open(value as string)}>
              <Icon
                w={8}
                h={10}
                alignSelf="center"
                alignItems="center"
                justifyContent="center"
                size="lg"
                color="system.success.default"
                name="download"
              />
              <Text
                variant="xSmallSemiBold"
                color="system.success.default">
                Baixar {name}
              </Text>
            </HStack>
          ) : (
            <Preview
              file={ref?.current?.files?.[0]}
              url={typeof value === 'string' ? value : undefined}
            />
          )}
        </Flex>
        <Icon
          hidden={!value || accept !== 'application/pdf'}
          cursor="pointer"
          onClick={() => {
            onChange(undefined);
          }}
          name="times"
          color="gray.600"
        />
        <Text
          hidden={!!ref?.current?.files?.[0] || typeof value === 'string'}
          variant="smallSemiBold"
          color="gray.500">
          {label ?? name}
        </Text>
      </HStack>
    </Flex>
  );
};
export default FileInput;
